import { gql, useMutation } from '@apollo/client';
import { useNavigate } from 'react-router';
import { useSetBreadcrumbEffect } from '../../contexts/BreadcrumbContext';
import { TeamsQuery } from '../../queries';
import TeamForm from './TeamForm';

const SuperadminCreateTeamMutation = gql`
  mutation CreateTeam($input: SuperadminCreateTeamInput!) {
    superadminCreateTeam(input: $input) {
      result {
        id
      }
      errors
    }
  }
`;

const CreateTeam = () => {
  const navigate = useNavigate();
  const [submitMutation] = useMutation(SuperadminCreateTeamMutation, {
    refetchQueries: [
      {
        query: TeamsQuery,
      },
    ],
    onCompleted: ({ superadminCreateTeam: { result } }) => {
      if (result) {
        navigate('/superadmin/teams');
      }
    },
    onError: (e) => {
      console.error(e);
    },
  });

  useSetBreadcrumbEffect([{ display: 'New' }], []);

  return (
    <TeamForm
      successMessage="Team created successfully"
      submitButtonText="Create"
      submitMutation={submitMutation}
    />
  );
};

export default CreateTeam;
